<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->
<button mat-icon-button="" type="button" (click)="onClick()" matTooltip="{{'lbl_clear' | translate}}" [hidden]="!canClear || control?.disabled">
  <mat-icon svgIcon="gh:close" class="s16"></mat-icon>
</button>